import React from "react";
import "./timeline_comp.scss";
import { Timeline } from "antd";

const Data = [
  {
    date: "2024-05-22",
    title: "Published",
  },
  {
    date: "2024-05-19",
    title: "Created and Scheduled",
    description: "Scheduled for 2024-05-22",
  },
];

const TimelineComp = ({ timelineData = Data }) => {
  return (
    <Timeline className="timeline-comp">
      {timelineData.map((item, index) => (
        <Timeline.Item key={index}>
          <div className="data-container">
            <h6 className="date-data">{item?.date}</h6>
            <div className="details-container">
              <h4 className="data-title">{item?.news_status_remarks}</h4>
              {item.description && (
                <h5 className="data-desc">{item?.description}</h5>
              )}
            </div>
          </div>
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default TimelineComp;
